import React from "react";
import styled from "styled-components";

export default function EntryQualificationInput(props) {
  const { value, setValue, placeholder } = props;

	function handleChange(e) {
    setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 5px 10px;

  width: calc(100% - 24px);

  border: 2px dashed #909090;
  border-radius: 5px;
  background-color: #444447;
`;

const Input = styled.input`
	font-family: NotoSansKR-Medium;
	font-size: 14px;
	line-height: 17px;

	width: 100%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
  text-align: right;
	color: #FFFFFF;

  border: none;
  background-color: #444447;

	::placeholder {
		color: #6A6A6C;
	}
  
  transition: all 0.3s ease-in-out;
`;